export default "__VITE_ASSET__345d263e__"